import ReactGA from 'react-ga';
import createHistory from 'history/createBrowserHistory';

const history = createHistory();

const matchProd = /https:\/\/www\.aloha50\.com/;
const isProd = window.location && window.location.toString().match(matchProd);

if (isProd) {
  ReactGA.initialize('UA-6715674-7');

  // basic page view tracking
  history.listen((location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });

  ReactGA.set({ page: history.location.pathname });
  ReactGA.pageview(history.location.pathname);
}

const tracking = {}; // API for tracking

export { history }; // to use in react-router

export default tracking;



// WEBPACK FOOTER //
// ./src/tracking/tracking.jsx